import * as Sentry from "@sentry/react";

const supabaseHost = new URL(import.meta.env.VITE_SUPABASE_URL).host;

Sentry.init({
    dsn: "https://bd9ae59d69141d2ba23302fc3926bd88@o4510752975290368.ingest.de.sentry.io/4510752977256528",
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
        // If you're using react router, use the integration for your react router version instead.
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Enable logs to be sent to Sentry
    enableLogs: true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled.
    // Derived from VITE_SUPABASE_URL so it automatically matches the correct
    // Supabase project host per environment (staging vs production) without
    // needing a separate hardcoded value.
    tracePropagationTargets: [/^\//, new RegExp(`^https://${supabaseHost}`)],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});